import http from '@http';
import toResponse from '@helpers/toResponse/toResponse';

export const sendPhoneNumber = (values) => toResponse(http.post('/send-code', values));

export const sendSmsCode = (values) => toResponse(http.post('/verify', values));
